export default __webpack_public_path__ + "static/media/edu.9bdb7b88.gif";